import React from 'react';
import {
  Popper, Fade, Paper, Button,
} from '@mui/material';
import { _t } from 'utils';

export default ({
  style = {}, outerStyle = {}, anchorEl = null, render, onClose = null, onApply = null, isActionButtons = true, className = '',
}) => {
  const open = Boolean(anchorEl);
  const id = open ? 'filter-popper' : undefined;

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorEl}
      transition
      style={outerStyle}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps}>
          <Paper style={{ ...style }} className={`popover ${className}`}>
            {render}
            {isActionButtons && (
              <div className="popover-footer">
                {onClose && <Button variant="contained" size="small" onClick={onClose}>{_t('Close')}</Button>}
                {onApply && <Button variant="contained" size="small" color="primary" onClick={onApply}>{_t('Clear')}</Button>}
              </div>
            )}
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};
